import PlaceIcon from "@mui/icons-material/Place";
import PhoneIcon from "@mui/icons-material/Phone";
import MailIcon from "@mui/icons-material/Mail";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
export const contactInfos = [
  {
    icon: <PlaceIcon fontSize="large" />,
    title: "Address",
    text: "North Port, Florida - 2704 Wyola Avenue",
  },
  {
    icon: <PhoneIcon fontSize="large" />,
    title: "Phone",
    text: "(941) 288-4338",
  },
  {
    icon: <MailIcon fontSize="large" />,
    title: "Email",
    text: "landscapingservicesal@gmail.com",
  },
  {
    icon: <WatchLaterIcon fontSize="large" />,
    title: "Work hours",
    text: "Mon-Fri, 8:30am - 6.30pm ",
  },
];
